import React from "react";
import styled from "styled-components";

import BigTooltip from "../common/BigTooltip";
import { affectsOf, formatShare } from "./criticality";

/** The row's criticality, the highest of `criticalities`, one per measure, with its share; the tooltip names each measure with a loss (criticality.js). */
export default function CriticalityPill({ criticality, criticalities }) {
    const share = formatShare(criticality.percent);
    const pill = (
        <Pill $criticality={criticality}>
            <Dot $color={criticality.color} />
            {criticality.label}
            {share && <Share>{share}</Share>}
        </Pill>
    );
    if (!share) return pill;
    return (
        <BigTooltip title={affectsOf(criticalities)} placement="top" arrow>
            {pill}
        </BigTooltip>
    );
}

/** Styled as the Drops page's severity badge (Drops/SeverityBadge.jsx). */
const Pill = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    justify-self: start;
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 500;
    white-space: nowrap;
    background: ${({ $criticality }) => $criticality.background};
    color: ${({ $criticality }) => $criticality.ink};
`;

const Dot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 999px;
    flex-shrink: 0;
    background: ${({ $color }) => $color};
`;

const Share = styled.span`
    font-variant-numeric: tabular-nums;
    opacity: 0.8;
`;
